import * as React from 'react';

function SvgNoSubscription(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M17 1.25c.38 0 .7.28.74.65l.01.1v1.25h2a2 2 0 012 1.85v14.65a2 2 0 01-2 2H4.25a2 2 0 01-2-2V5.25c0-1.1.9-2 2-2h2V2a.75.75 0 011.5-.1v1.35h8.5V2c0-.41.34-.75.75-.75zM20.25 9H3.75v10.25a1 1 0 00.88 1h14.62a1 1 0 001-1V9zm-5.46 1.3l1.42 1.4-2.8 2.8 2.8 2.8-1.42 1.4L12 15.92l-2.8 2.8-1.4-1.42 2.79-2.79-2.8-2.8 1.42-1.4L12 13.08l2.8-2.8zm4.46-5.55H4.75a1 1 0 00-1 1V7h16.5V5.75a1 1 0 00-.88-1h-.12z" />
    </svg>
  );
}

export default SvgNoSubscription;
